import * as React from "react";
import Box from "@mui/material/Box";
import Stepper from "@mui/material/Stepper";
import Step from "@mui/material/Step";
import StepLabel from "@mui/material/StepLabel";

const steps = [
  "สร้างใบแจ้งหนี้",
  "ขออนุมัติใบแจ้งหนี้",
  "รอรับชำระ",
  "ชำระเเล้ว",
];

export default function PrStep({ activeStep, canceled = false }) {
  return (
    <Box sx={{ width: "600px" }} mx={"auto"} mb={3} mt={1}>
      <Stepper activeStep={canceled ? -1 : activeStep} alternativeLabel>
        {steps.map((label) => (
          <Step key={label}>
            <StepLabel sx={{ ".MuiStepLabel-label": { marginTop: "8px" } }}>
              {label}
            </StepLabel>
          </Step>
        ))}
      </Stepper>
    </Box>
  );
}
